/**
 * React Query keys an agent `object_update` refreshes, by convention: object type
 * `health_record` maps to `['health-records']` (list) and `['health-record', id]` (detail).
 * Domain hooks (platform or pack) that follow the convention stay fresh without core wiring.
 */
export function objectUpdateQueryKeys(objectType: string, objectId: string): string[][] {
  const base = objectType.trim().toLowerCase().replace(/[_\s]+/g, '-')
  if (!base || !objectId) return []
  return [[`${base}s`], [base, objectId]]
}
